import { render, staticRenderFns } from "./CustomValue.vue?vue&type=template&id=6f06cace&scoped=true"
import script from "./CustomValue.vue?vue&type=script&lang=js"
export * from "./CustomValue.vue?vue&type=script&lang=js"
import style0 from "./CustomValue.vue?vue&type=style&index=0&id=6f06cace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06cace",
  null
  
)

export default component.exports